import { XMarkIcon } from "@heroicons/react/24/outline";
import { monthsLowerCase } from "../../consts/forecast";
import { monthKeysFullnameEnum } from "../../consts/quickbooksReports";
import { ForecastTotals } from "./ForecastTotals";

export const RevenueForecastPreview = ({
    data,
    totals,
    period,
    opened,
    onClose,
    marginFromSidebar
}) => {
    if (!opened) return null;

    // Calculate total revenue for all products
    const totalRevenue = data.reduce((sum, item) => {
        const itemTotal = Object.values(item.total_revenue || {}).reduce((a, b) => a + Number(b), 0);
        return sum + itemTotal;
    }, 0);

    return (
        <section 
            className="fixed h-full top-0 bg-white p-8"
            style={{ width: `calc(100% - ${Number(marginFromSidebar || 0)}px)`, transition: "all" }}
        >
            <div className="flex w-full justify-end">
                <button>
                    <XMarkIcon className="h-5 w-5" onClick={onClose}/>
                </button>
            </div>
            <div className="w-full h-full px-6 pt-2 pb-6 flex flex-col gap-4 justify-center">
                <h3 className="text-4xl font-bold text-gray-900 mb-4">
                    Annual Revenue Forecast {period || ""}
                </h3>
                <ForecastTotals
                    totals={totals}
                />
                <div className="rounded-lg border bg-card text-card-foreground shadow-2xs">
                    <div className="p-6 pt-0">
                        <div className="overflow-x-auto">
                            <div className="relative w-full overflow-auto max-h-[600px]">
                                <table className="w-full caption-bottom text-sm">
                                    <thead>
                                        <tr className="border-b transition-colors hover:bg-gray-50">
                                            <th className="h-12 px-4 text-left align-middle font-semibold text-[#71717a]">
                                                Product
                                            </th>
                                            <th className="h-12 px-4 align-middle text-center font-semibold text-[#71717a]">
                                                % of Revenue
                                            </th>
                                            <th className="h-12 px-4 align-middle text-right font-semibold text-[#71717a]">
                                                Total Revenue
                                            </th>
                                            {monthsLowerCase.map((month) => (
                                                <th key={month} className="h-12 px-4 align-middle text-right font-semibold text-xs text-[#71717a] min-w-[150px]">
                                                    {monthKeysFullnameEnum[month]} {period || ""}
                                                </th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.map((item, index) => {
                                            const itemTotalRevenue = Object.values(item.total_revenue || {}).reduce((sum, val) => sum + Number(val), 0);
                                            const percentage = totalRevenue ? ((itemTotalRevenue / totalRevenue) * 100).toFixed(1) : "0.0";
                                            
                                            return (
                                                <tr 
                                                    className={`border-b transition-colors hover:bg-gray-50 ${index % 2 ? "bg-white" : "bg-[#eef6ff]"}`}
                                                    key={`${item.name}_${index}`}
                                                >
                                                    <td className="p-4 align-middle whitespace-nowrap overflow-hidden text-ellipsis">
                                                        {item.name || "-"}
                                                    </td>
                                                    <td className="p-4 align-middle text-center">
                                                        <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors border-transparent bg-[#f4f4f5]">
                                                            {percentage}%
                                                        </div>
                                                    </td>
                                                    <td className={`p-4 align-middle text-right font-medium`}>
                                                        ${itemTotalRevenue.toLocaleString()}
                                                    </td>
                                                    {monthsLowerCase.map((month) => (
                                                        <td className={`p-4 align-middle text-right text-sm ${item.total_revenue?.[month] ? "" : "text-[#71717a]"}`} key={month}>
                                                            ${(Number(item.total_revenue?.[month] || 0)).toLocaleString()}
                                                        </td>
                                                    ))}
                                                </tr>    
                                            )
                                        })}
                                        <tr className="border-b transition-colors bg-gray-100 font-semibold">
                                            <td className="p-4 align-middle">Total Revenue</td>
                                            <td className="p-4 align-middle text-center">
                                                <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors bg-[#18181b] text-white">
                                                    100%
                                                </div>
                                            </td>
                                            <td className="p-4 align-middle text-right">${totalRevenue.toLocaleString()}</td>
                                            {monthsLowerCase.map((month) => (
                                                <td className="p-4 align-middle text-right text-sm" key={month}>
                                                    ${data.reduce((sum, item) => sum + Number(item.total_revenue?.[month] || 0), 0).toLocaleString()}
                                                </td>
                                            ))}
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </section>
    )
}